import { render, staticRenderFns } from "./send_auth.vue?vue&type=template&id=6e69c8c1&lang=pug&"
import script from "./send_auth.vue?vue&type=script&lang=js&"
export * from "./send_auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e69c8c1')) {
      api.createRecord('6e69c8c1', component.options)
    } else {
      api.reload('6e69c8c1', component.options)
    }
    module.hot.accept("./send_auth.vue?vue&type=template&id=6e69c8c1&lang=pug&", function () {
      api.rerender('6e69c8c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/mail/send_auth.vue"
export default component.exports